import { Group } from 'components/Wizards/Catalogue/Types'

export const VISUAL_GROUPS: Array<Group> = [
  {
    name: 'Social Media',
    channels: [
      'instagram-square-post',
      'instagram-story',
      'instagram-reel',
      'instagram-portrait-post',
      'instagram-landscape-post',
      'tik-tok-post',
      'tik-tok-thumbnail',
      'youtube-channel-art',
      'youtube-profile-picture',
      'facebook-profile-picture',
      'facebook-cover',
      'facebook-post',
      'linkedin-profile-picture',
      'linkedin-post',
      'linkedin-banner',
      'whatsapp-sticker',
      'pinterest',
      'twitter-post',
      'twitter-profile-picture',
      'twitter-cover-image',
      'landscape-post',
      'portrait-post',
      'square-post',
    ],
  },
  {
    name: 'Marketplace',
    channels: [
      'facebook-marketplace',
      'ebay',
      'poshmark',
      'depop',
      'mercari',
      'mercadolibre',
      'shopee',
      'lazada',
      'etsy',
      'vinted',
      'amazon',
      'shopify-square',
    ],
  },
]
